import {useInjection} from "inversify-react";
import {useCallback, useEffect, useState} from "react";
import ApiService from "../../../services/apiService";
import {TagApi, TagCreateDto, TagDto, TagUpdateDto} from "../../../api";
import TagModalForm from "./tagModalForm";
import {useParams} from "react-router-dom";


export default function TagModalFormAddContainer(props: TagModalFormAddContainerProps) {
    const apiService = useInjection(ApiService);
    const [tagToEdit, setTagToEdit] = useState<TagUpdateDto | null>(null);
    let {productId} = useParams();

    const onSubmit = useCallback(async (values: TagCreateDto | TagUpdateDto) => {
        values?.productsIds !== undefined && values?.productsIds !== null ? values.productsIds.push(+productId!) : values.productsIds = [+productId!]

        try {
            if (values?.id) {
                await apiService.getApi(TagApi).apiTagIdPut(values.id, values)
            } else if (!props.id) {
                await apiService.getApi(TagApi).apiTagPost(values);
            } else {
                await apiService.getApi(TagApi).apiTagIdPut(props.id, values)
            }

            await props.onFinish(true);
        } catch (e: any) {
            return e.response.data;
        }
    }, [apiService, props.id]);

    const getTagToEdit = useCallback(async () => {

        if (!props.id) {
            return;
        }

        const response = await apiService.getApi(TagApi).apiTagIdGet(props.id);

        setTagToEdit(response.data);

    }, [apiService, props.id]);

    useEffect(() => {
        getTagToEdit();
    }, [getTagToEdit]);

    if (props.id && !tagToEdit) {
        return null;
    }
    return <>
        <TagModalForm
            isModalVisible={props.addFormVisibility}
            setModalVisibility={props.onFinish}
            onSubmit={onSubmit}
            modalTitle={props.title}
            saveButtonTitle={"Zapisz"}
            cancelButtonTitle={"Anuluj"}
            initialValues={tagToEdit!}
        />
    </>
}

interface TagModalFormAddContainerProps {
    onFinish: (refreshList: boolean) => void,
    addFormVisibility: boolean,
    title: string,
    id?: number | null
}
